import React from 'react';
import { CustomTooltip } from '../BuildingBlocks/Tooltip/Tooltip';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import makeStyles from '@material-ui/core/styles/makeStyles';
import companyInfo from '../../themes/themes';

const useStyles = makeStyles((theme: any) => ({
  header: { cursor: 'default' },
  statusHeader: { textAlign: 'center' },
}));

export default function TableHeaders({ includeStatus }) {
  const theme = process.env.REACT_APP_THEME;

  const headers = [
    { name: 'Date' },
    {
      name: 'Receive',
      hover: `Amount you’ll receive from ${companyInfo[theme].company}, then use to pay for the stages in your supply chain.`,
    },
    {
      name: 'Participation',
      hover:
        "Per the terms of your Growth Plan, this is the amount you'll be responsible to cover for COGS. Participation is deducted from the amount you'll receive.",
    },
    {
      name: 'Remit',
      hover: `This is the amount you’re due to remit to ${companyInfo[theme].company}, and includes your cost of capital. You can request to change the date of upcoming remittances.`,
    },
  ];
  const classes = useStyles();

  if (includeStatus) {
    headers.push({ name: 'Status' });
    headers.push({ name: '' }); //for the request change
  }

  const showHeader = (header: any) => {
    const headerCell = (
      <TableCell
        className={
          classes.header +
          ' ' +
          (header.name === 'Status' && classes.statusHeader)
        }
      >
        <b>{header?.name}</b>
      </TableCell>
    );

    return (
      <>
        {header?.hover && (
          <CustomTooltip
            arrow
            placement="bottom"
            title={header?.hover ? header.hover : null}
          >
            {headerCell}
          </CustomTooltip>
        )}
        {!header?.hover && headerCell}
      </>
    );
  };

  return (
    <TableHead>
      <TableRow>
        {headers.map((h) => (
          <React.Fragment key={h.name}>{showHeader(h)}</React.Fragment>
        ))}
      </TableRow>
    </TableHead>
  );
}
